import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { PaginationIF } from '@/types/common';
import { authApi } from '@/api/authApi/authApi';
import { favoritesApi } from '@/api/favoritesApi/favoritesApi';
import { FavoriteIF } from '@/api/favoritesApi/types';
import {
    FAVORITE_ENTITIES,
    FavoriteEntityT,
} from '@/constants/favoriteEntities';

export type UseFavoritesT = Record<
    FavoriteEntityT,
    PaginationIF<FavoriteIF> | null
>;

export const useFavoritesList = (): UseFavoritesT => {
    const currentUser = useSelector(
        (state: RootState) =>
            authApi.endpoints.getCurrentUser.select()(state).data,
    );

    const favoriteQueries = FAVORITE_ENTITIES.map(({ value }) =>
        favoritesApi.useGetFavoritesListQuery(value, {
            skip: !currentUser,
        }),
    );

    return useMemo(() => {
        const result = {} as UseFavoritesT;

        for (const [index, FAVORITE_ENTITY] of FAVORITE_ENTITIES.entries()) {
            const entityName = FAVORITE_ENTITY.value;
            result[entityName] = favoriteQueries[index]?.data || null;
        }

        return result;
    }, [favoriteQueries]);
};
